import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr/toastr/toastr-service';

@Injectable()
export class ToastrAlertHelper {
  constructor(private toastrService: ToastrService) {}

  show(message: string, title?: string, optionsOverride?: any) {
    return this.toastrService.show(message, title, optionsOverride);
  }

  success(message: string, title?: string, optionsOverride?: any) {
    return this.toastrService.success(message, title, optionsOverride);
  }

  error(message: string, title?: string, optionsOverride?: any) {
    return this.toastrService.error(message, title, optionsOverride);
  }

  info(message: string, title?: string, optionsOverride?: any) {
    return this.toastrService.info(message, title, optionsOverride);
  }

  warning(message: string, title?: string, optionsOverride?: any) {
    return this.toastrService.warning(message, title, optionsOverride);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/helpers/toastr-alert-helper-service.ts